import { AdicionarCartao, ContainerCartoes } from "./styles";
import { Cartao } from "../../../../components/Cartao";
import ModalCadastrarCartao from "../cadastrarCartao/CadastrarCartao";
import { IconeBotao } from "../../../selecaoEmpresas/styles";
import { ReactComponent as IconeMais } from "../../../../assets/icons/icone_mais.svg";
import { useEffect, useState } from "react";
import { ResponsePagamentoCartao } from "../../../../services/contrato/MapperPagamentoCartao";
import { toast } from "react-toastify";
import { useApi } from "../../../../contexts/api";
import useTamanhoTela from "../../../../utils/useTamanhoTela";
import Carregando from "../../../carregando";
import { useTranslation } from "react-i18next";

export default function ListagemCartao() {
  const { t } = useTranslation("common");
  const { t: tPagamento } = useTranslation("pagamento");
  const { get, put, del } = useApi();

  const [loading, setLoading] = useState(true);
  const [listaCartoes, setListaCartoes] = useState([]);

  useEffect(() => {
    buscarCartoes();
  }, []);

  function buscarCartoes() {
    get("/pagamento/cartao")
      .then((response) => {
        let data = ResponsePagamentoCartao.mapLista(response.data);

        setListaCartoes(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(true);
        setListaCartoes([]);
        console.error(error);
        toast.error(tPagamento("cards.listLoadError"));
      });
  }

  function removerCartao(id, fechar) {
    del("/pagamento/cartao/" + id)
      .then((response) => {
        toast.info(tPagamento("cards.deleted"));

        const cartoesNovo = listaCartoes.filter((cartao) => cartao.id !== id);

        setListaCartoes(cartoesNovo);
        fechar();
      })
      .catch((error) => {
        console.error(error);
        toast.error(tPagamento("cards.deleteError"));
      });
  }

  function definirComoPadrao(idNovoCartaoPadrao) {
    put("/pagamento/cartao/principal/" + idNovoCartaoPadrao)
      .then((response) => {
        toast.info(tPagamento("cards.defaultSet"));

        const cartoesNovo = listaCartoes.map((cartao) =>
          mapCartoesParaPadrao(cartao, idNovoCartaoPadrao),
        );

        setListaCartoes(cartoesNovo);
      })
      .catch((error) => {
        console.error(error);
        toast.error(tPagamento("cards.defaultSetError"));
      });
  }

  function mapCartoesParaPadrao(cartao, idCartaoPadrao) {
    if (cartao.id === idCartaoPadrao) {
      return { ...cartao, cartaoPadrao: true };
    }

    return { ...cartao, cartaoPadrao: false };
  }

  return loading ? (
    <Carregando adaptavel />
  ) : (
    <ContainerCartoes>
      {listaCartoes.map((informacoes) => (
        <Cartao
          key={informacoes.id}
          id={informacoes.id}
          nome={informacoes.nomeDonoCartao}
          numero={informacoes.finalCartao}
          cartaoPadrao={informacoes.cartaoPadrao}
          onRemove={(fechar) => removerCartao(informacoes.id, fechar)}
          onClickDefinirComoPadrao={() => definirComoPadrao(informacoes.id)}
          editavel
          onEditar={() => buscarCartoes()}
        />
      ))}
      {listaCartoes.length < 2 && (
        <AdicionarCartao>
          <ModalCadastrarCartao
            componenteTrigger={
              <IconeBotao>
                <IconeMais />
              </IconeBotao>
            }
            onCadastradoComSucesso={() => buscarCartoes()}
          />
        </AdicionarCartao>
      )}
    </ContainerCartoes>
  );
}
